export function showAllAction() {
  const { t } = useI18n();

  return {
    getTitle: () => t('components.xeokit_viewer.context_menu.show_all') || 'Show All',
    getEnabled: function (context) {
      const scene = context.viewer.scene;
      return (
        scene.numVisibleObjects < scene.numObjects ||
        scene.numXRayedObjects > 0 ||
        scene.numSelectedObjects > 0
      );
    },
    doAction: function (context) {
      const scene = context.viewer.scene;
      scene.setObjectsVisible(scene.objectIds, true);
      scene.setObjectsXRayed(scene.xrayedObjectIds, false);
      scene.setObjectsSelected(scene.selectedObjectIds, false);
    },
  };
}
